export const isGeolocationSupported = (): boolean => !!navigator.geolocation
